const initialState = {
    branchId: '0', 
    shopTitle: '',
    branchTitle: '',
    amount: '',
    file: false,
    services: [],
    serviceSelected: null,
    disableBtn: true,
    btnClass: 'disable-btn',
};
const installmentsUpload = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_INSTALLMENTS_UPLOAD_FACTOR_PAGE':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default installmentsUpload;
